// import Api from 'services/Api'
import { client } from '@/api/ClientContainer'
import { BlankNewCustomerStatus } from '@/services/const'
import { make } from 'vuex-pathify'

// Store states
const state = {
  loading: false,
  // showSummary: false,
  data: {
    nip: null,
    token: null,
    currentStep: 0
  },
  steps: [
    { number: 1, label: 'Dane podstawowe' },
    { number: 2, label: 'Dane do umowy' },
    { number: 3, label: 'Osoba kontaktowa' },
    { number: 4, label: 'Komunikaty' },
    { number: 5, label: 'Karty paliwowe' },
    { number: 6, label: 'Załączniki' }
  ]
}

// Store custom getters
const customGetters = {
  limitStep: (state) => (step) => {
    // Sprawdzenie i ewentualna korekta kroku
    // Mozna się cofnąc tylko do kroku 1
    if (step < 1) {
      step = 1
    }

    // Można dojść do kroku, o jeden dalej niż zatwierdzony
    if (step > state.data.lastStepTaken + 1) {
      step > state.data.lastStepTaken + 1
    }
    return step
  },
  isStepChangeAllowed: (state) => (step) => {
    if (step < 1) {
      return false
    }

    // Można dojść do kroku, o jeden dalej niż zatwierdzony
    if (step > state.data.lastStepTaken + 1) {
      return false
    }

    return true
  },
  token() {
    if (state.data && state.data.token && state.data.token) {
      return state.data.token
    }

    return null
  },
  isFromGroupOrAuction() {
    if (
      state.data.isFromAuction ||
      state.data.customerGroupId ||
      state.data.customerGroupCode
    ) {
      return true
    }

    return false
  }
}

// Store custom actions
const customActions = {
  // Niestandardowe akcje tutaj lub w dedykowanej usludze. Chyba lepiej w store,
  //  co najwyżej wyrzucić do dedykowanego pliku gdy bedzie duzo akcji, np. dictionaryActions.js
  //  Dedykowany service aby obsługiwać całość zadan musiałby też mapować gettery, a nie o to raczej chodzi.

  // manually add load items action
  load({ commit }, blankToken) {
    // Items are being loaded, return promise
    if (state.loading) {
      return
    }

    // // Store data already loaded
    // if (state.data.token && !force) {
    //   // console.log('aborting - already loaded')
    //   return;
    // }

    commit('SET_LOADING', true)

    // dispatch("loader/startLoading", 'blank', { root: true });

    return client.blank
      .get(blankToken)
      .then(function (data) {
        // handle success
        // Remove nip created from blank numer
        if (data.nip && data.nip.substring(0, 3) == '000') {
          data.nip = ''
        }

        // Force step 7 after PH acceptance
        if (data.status >= BlankNewCustomerStatus.REQ_ACC_PH) {
          data.currentStep = 7
        }

        // dispatch('blank', data)
        // commit('SET_DATA', JSON.parse(JSON.stringify(data)))
        commit('SET_DATA', data)
      })
      .catch(function (error) {
        // return error;
        return Promise.reject(error)
      })
      .finally(function () {
        // console.log('finished loading')
        commit('SET_LOADING', false)
        // dispatch("loader/finishLoading", 'blank', { root: true });
      })
  },

  setData({ commit }, data) {
    commit('SET_DATA', data)
    commit('SET_LOADING', false)
  },

  previousStep({ dispatch }) {
    // console.log('previousStep')
    let step = state.data.currentStep - 1
    if (step < 1) {
      step = 1
    }

    return dispatch('changeStep', step)
  },

  changeStep({ commit, getters }, step) {
    // console.log('changeStep')
    let blankToken = getters.token

    if (step == state.data.currentStep) {
      return
    }

    // Items are being loaded, return promise
    if (state.loading) {
      return
    }

    if (!getters.isStepChangeAllowed(step)) {
      return
    }

    commit('SET_LOADING', true)

    return client.blank
      .step(blankToken, step)
      .then(function (data) {
        // handle success
        // console.log(JSON.parse(JSON.stringify(data)))
        // dispatch('blank', data)
        // commit('SET_DATA', JSON.parse(JSON.stringify(data)))
        // data.token = data.token.value
        commit('SET_DATA', data)
      })
      .finally(function () {
        // console.log('finished loading')
        commit('SET_LOADING', false)
      })
  },

  nextStep({ commit }, blank) {
    // console.log('store: nextStep')

    // // Items are being loaded, return promise
    // if (state.loading) {
    //   return;
    // }

    commit('SET_LOADING', true)

    return client.blank
      .nextStep(blank)
      .then(function (data) {
        // handle success
        commit('SET_DATA', data)
      })
      .finally(function () {
        // console.log('finished loading')
        commit('SET_LOADING', false)
      })
  },

  survey({ commit }, formData) {
    // // Items are being loaded, return promise
    // if (state.loading) {
    //   return;
    // }

    // Nie powinno być potrzebne, te dane są już w formularzu, a walidacja po stronie
    //  serwera musi wykrywać ewentualne problemy
    // blank.token = state.data.token
    // blank.step = state.data.currentStep
    commit('SET_LOADING', true)

    let blank = { ...state.data }
    blank.survey = formData

    return client.blank
      .survey(blank)
      .then(function (data) {
        // handle success
        commit('SET_DATA', data)
      })
      .finally(function () {
        // console.log('finished loading')
        commit('SET_LOADING', false)
      })
  }
}

// ---------------------------------------------
// Create store
// make all mutations and getters
const mutations = make.mutations(state)
const getters = {
  ...make.getters(state),
  ...customGetters
}
// const actions = make.actions(state)
const actions = {
  // automatically create only `setData()` action
  // ...make.actions('data'),
  // ...make.actions('data@token'),
  ...customActions
}

export default {
  namespaced: true, // add this if in module
  state,
  mutations,
  actions,
  getters
}
